import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { auth, googleProvider } from './firebase';
import { setUser } from './redux/authSlice';
import { FcGoogle } from 'react-icons/fc';
import { ArrowLeft } from 'lucide-react';
import './Login.css'; // Reuse Login styles

const Registration = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      dispatch(setUser(userCredential.user));
      navigate('/dashboard');
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      dispatch(setUser(result.user));
      navigate('/dashboard');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg-glow" />
      <div className="auth-bg-grid" />

      <Link to="/" className="auth-back">
        <ArrowLeft size={16} />
        Back to home
      </Link>

      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-logo">
            Vendor<span>Scout</span>
          </div>
          <h1 className="auth-title">Create an account</h1>
          <p className="auth-subtitle">Get started with VendorScout for free</p>
        </div>

        <div className="auth-card">
          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                id="email"
                className="form-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                id="password"
                className="form-input"
                placeholder="Create a password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="auth-submit">Create Account</button>
          </form>

          <div className="auth-separator">
            <div className="auth-separator-line" />
            <span className="auth-separator-text">or</span>
            <div className="auth-separator-line" />
          </div>

          <button onClick={handleGoogleSignIn} className="auth-social">
            <FcGoogle />
            Continue with Google
          </button>
        </div>

        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default Registration;
